import { SxProps, Theme } from '@mui/material';

export const cardSx: SxProps<Theme> = {
  mb: 2,
  backgroundColor: '#1a1a1a',
  border: '1px solid #333',
  borderRadius: 2,
  overflow: 'hidden'
};

export const headerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#464545',
  color: 'white',
  p: 2
};

export const buttonGenerateInvoiceSx: SxProps<Theme> = {
  bgcolor: '#3b82f6',
  color: 'white',
  '&:hover': { bgcolor: '#2563eb' },
  textTransform: 'none',
  fontWeight: 600
};

export const buttonDownloadPdfSx = (hasInvoice: boolean): SxProps<Theme> => ({
  bgcolor: hasInvoice ? '#f59e0b' : '#6b7280',
  color: 'white',
  '&:hover': { bgcolor: hasInvoice ? '#d97706' : '#4b5563' },
  textTransform: 'none',
  fontWeight: 600
});

export const buttonSendInvoiceSx: SxProps<Theme> = {
  bgcolor: '#22c55e',
  color: 'white',
  '&:hover': { bgcolor: '#16a34a' },
  textTransform: 'none',
  fontWeight: 600
};

export const cardContentSx: SxProps<Theme> = {
  backgroundColor: '#161616',
  color: 'white',
  p: 3
};

export const alertErrorSx: SxProps<Theme> = {
  mb: 2,
  backgroundColor: 'rgba(239, 68, 68, 0.1)',
  color: '#ef4444',
  '& .MuiAlert-icon': { color: '#ef4444' }
};

export const alertSuccessSx: SxProps<Theme> = {
  mb: 2,
  backgroundColor: 'rgba(34, 197, 94, 0.1)',
  color: '#22c55e',
  '& .MuiAlert-icon': { color: '#22c55e' }
};

export const statusBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  p: 2,
  backgroundColor: 'rgba(8, 145, 178, 0.1)',
  borderRadius: 1,
  border: '1px solid rgba(8, 145, 178, 0.3)'
};

export const chipSx = (isCurrent: boolean): SxProps<Theme> => ({
  fontWeight: isCurrent ? 600 : 400,
  fontSize: '0.875rem',
  opacity: isCurrent ? 1 : 0.7,
  cursor: isCurrent ? 'default' : 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    opacity: 1,
    transform: isCurrent ? 'none' : 'scale(1.05)',
    boxShadow: isCurrent ? 'none' : '0 2px 8px rgba(0,0,0,0.3)'
  },
  '&.Mui-disabled': {
    opacity: 0.5
  }
});

export const loadingBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
  mt: 2,
  p: 2,
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  borderRadius: 1
};